<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-08-29 14:49:01
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2025-11-13 15:39:56
 * @FilePath: \qctsw-vue\packages\app\src\pages\search\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script lang='ts' setup>
import complaintList from './components/complaintList.vue'
import articleList from './components/articleList.vue'
import { usePagination } from '@/composables/usePagination'
import { searchArticleApi, searchComplaintApi } from '@/server'
import { LOAD_STATE } from '~/shared/types'

const route = useRoute()
const title = computed(() => route.query.title as string || '')

const stop = watch(title, () => {
  getNewsPage()
})

onUnmounted(() => {
  stop && stop()
})

const list = ref([
  {
    name: '投诉',
    fn: usePagination({
      type: 'up',
      key: '20',
      pageSize: 20,
      onlyClient: false,

      request: params => searchComplaintApi({ ...params, title: title.value }),
    }),
  },
  {
    name: '资讯',
    fn: usePagination({
      type: 'up',
      key: '20',
      pageSize: 20,
      onlyClient: true,
      request: params => searchArticleApi({ ...params, title: title.value }),
    }),
  },
])

const tabs = ref(0)
const isSearch = ref(false)

const data = ref<any>([])

async function getNewsPage(page: number | string = 1) {
  const p = Number.isNaN(Number(page)) ? 1 : Number(page)

  // if (p === 1) {
  //   data.value = []
  //   window && window.scroll(0, 0)
  // }

  const { list: data1 } = await list.value[tabs.value].fn.loadPaginationData(p, {
    title: title.value,
  }) || {}

  if (!data1?.length)
    return

  data.value.push(...data1)
  isSearch.value = true
}

function search() {
  data.value = []
  list.value[tabs.value].fn.setPaginationStatus(LOAD_STATE.INIT)
  list.value[tabs.value].fn.setPage(1)
  getNewsPage()
}
getNewsPage()

function getMore() {
  getNewsPage(list.value[tabs.value].fn.pagination.page++)
}
</script>

<template>
  <div class="w-300 m-auto">
    <n-tabs v-model:value="tabs" trigger="hover" type="line" @update:value=" search">
      <n-tab v-for="item, index in list" :key="index" :name="index">
        {{ item.name }}
      </n-tab>
    </n-tabs>
    <div class="flex mt-5">
      <div class="flex-grow mb-5 min-w-200">
        <NuxtLink v-if=" tabs === 0" class="text-blue-5 text-right w-full block" to="/complaint/search">
          投诉精细搜索
        </NuxtLink>
        <UtilLoadState :length="data.length" type="up" :state="list[tabs].fn.pagination.status" :reload-handler="() => getNewsPage">
          <template #loading>
            <span v-if="!isSearch" />
            <!-- <SkeletonArticle v-for="v in 10" :key="v" mb-sm /> -->
          </template>
          <template v-if="data && data.length">
            <baseList :state="list[tabs].fn.pagination.status" @load="getMore">
              <component :is="tabs === 0 ? complaintList : articleList" :list="data" />
            </baseList>
          </template>
          <BasicEmpty v-else />
        </UtilLoadState>

        <!-- <BasicPagination
          v-show="list[tabs].fn.pagination.pageCount"
          class="mt-xl"
          :page="list[tabs].fn.pagination.page"
          :total="list[tabs].fn.pagination.pageCount"
          item-tag="div"
          :to="(p) => {

            getNewsPage(p)
          }"
        /> -->
      </div>

      <div class="flex-shrink-0 w-[calc(100%-53rem)] pl-xl ">
        <ClientOnly>
          <RankHotComplaint class="mb-sm" />
          <RankHotNews class="sticky top-39" />
        </ClientOnly>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped></style>
